import { render, staticRenderFns } from "./TitledWarning.vue?vue&type=template&id=1bf40190&"
import script from "./TitledWarning.vue?vue&type=script&lang=js&"
export * from "./TitledWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports